import React from 'react';
import moment from 'moment';
import {
	getFormattedPercentage,
	getFormattedSpendWithSymbol,
} from 'utils/number';
import {
	HeadlinesContainer,
	HeadlinesTitle,
	HeadlinesLabel,
	HeadlinesValue,
} from './TaxonomyPreview.styles';

export default ({ currencySymbol, companies }) => {
	const {
		dateFrom,
		dateTo,
		l4CategoriesCount,
		spend,
		totalSpend,
		vendorsCount,
	} = companies.reduce(
		(acc, company) => {
			const currDateFrom = new Date(acc.dateFrom).getTime();
			const currDateTo = new Date(acc.dateTo).getTime();
			const companyDateFrom = new Date(company.dateFrom).getTime();
			const companyDateTo = new Date(company.dateTo).getTime();
			const dateFrom =
				currDateFrom < companyDateFrom ? acc.dateFrom : company.dateFrom;
			const dateTo = currDateTo > companyDateTo ? acc.dateTo : company.dateTo;
			return {
				dateFrom,
				dateTo,
				l4CategoriesCount: acc.l4CategoriesCount + company.l4CategoriesCount,
				spend: acc.spend + company.spend,
				totalSpend: acc.totalSpend + company.totalSpend,
				vendorsCount: acc.vendorsCount + company.vendorsCount,
			};
		},
		{
			dateFrom: '',
			dateTo: '',
			l4CategoriesCount: 0,
			spend: 0,
			totalSpend: 0,
			vendorsCount: 0,
		}
	);
	const period = `${moment(dateFrom).format('MMM YYYY')} - ${moment(
		dateTo
	).format('MMM YYYY')}`;
	return (
		<HeadlinesContainer>
			<HeadlinesTitle>Indirect spend</HeadlinesTitle>

			<HeadlinesLabel>Time period</HeadlinesLabel>
			<HeadlinesValue>{period}</HeadlinesValue>

			<HeadlinesLabel>Total spend</HeadlinesLabel>
			<HeadlinesValue>
				{getFormattedSpendWithSymbol(totalSpend, currencySymbol)}
			</HeadlinesValue>

			<HeadlinesLabel>Indirect spend</HeadlinesLabel>
			<HeadlinesValue>
				{getFormattedSpendWithSymbol(spend, currencySymbol)} ({getFormattedPercentage(
					(spend / totalSpend) * 100
				)})
			</HeadlinesValue>

			<HeadlinesLabel>Number of indirect L4 categories</HeadlinesLabel>
			<HeadlinesValue>{l4CategoriesCount}</HeadlinesValue>

			<HeadlinesLabel>Number of indirect vendors</HeadlinesLabel>
			<HeadlinesValue>{vendorsCount}</HeadlinesValue>
		</HeadlinesContainer>
	);
};
